import React from 'react'
import { Modal as BootstrapModal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../components/Modal/Modal'
import { Button } from '../../../components/Button/Button'
import type { TemplateReferenceItem } from '../../../store/templateLibrary/templateLibrary'
import './TemplateUsedInModal.scss'

interface TemplateUsedInModalProps {
  show: boolean
  items: TemplateReferenceItem[]
  onClose: () => void
}

export const TemplateUsedInModal: React.FC<TemplateUsedInModalProps> = ({ show, items, onClose }) => {
  const navigate = useNavigate()

  const handleOpen = (item: TemplateReferenceItem) => {
    if (item.kind === 'meeting_template') {
      navigate(`/workspace/setup/meeting-types/meeting-type/details/${item.id}/presets`)
    }
    onClose()
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      header={<BootstrapModal.Title>Where this template is used</BootstrapModal.Title>}
      headerBodySeparator
      body={
        <div className='template-used-in-modal d-flex flex-column gap-4'>
          <div className='template-used-in-modal__list d-flex flex-column'>
            {items.map((item, index) => (
              <div
                key={item.id}
                className={`d-flex align-items-center justify-content-between gap-3 px-3 py-2 ${index > 0 ? 'border-top zocks-border-color-gray-300' : ''}`}
              >
                <span className='paragraph-medium zocks-text-gray-900'>{item.name}</span>
                <Button
                  variant='link'
                  className='template-used-in-modal__open d-inline-flex align-items-center gap-1 p-0 text-decoration-none zocks-text-primary'
                  onClick={() => handleOpen(item)}
                >
                  <span>Open</span>
                  <i className='bi bi-arrow-up-right' />
                </Button>
              </div>
            ))}
          </div>
          <div className='d-flex align-items-center gap-2 paragraph-medium zocks-text-gray-700'>
            <i className='bi bi-info-square' />
            <span>Refresh the page to see changes made on other tabs.</span>
          </div>
        </div>
      }
      showFooterActions
      hideSecondaryAction
      footerPrimaryActionTitle='Done'
      onFooterPrimaryAction={onClose}
      centered
    />
  )
}
